<template>
  <div class="otherOrder">
    <el-divider content-position="left">云上工商订单</el-divider>
    <el-collapse v-model="activeOpen">
      <el-collapse-item title="高级筛选">
        <div style="padding: 10px">
          <el-row :gutter="100">
            <el-col :span="6" class="col-style">
              订单状态:
              <el-select class="ml-2" @click.native="loadOrderStatus" v-model="searchArr.order_status" placeholder="请选择"
                size="mini" clearable filterable>
                <el-option v-for="(item, index) in orderStatusOptions" :value="item" :label="item" :key="index">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6" class="col-style">
              沟通状态:
              <el-select class="ml-2" v-model="searchArr.chat_status" placeholder="请选择" size="mini" clearable>
                <el-option :value="1" label="未分配"></el-option>
                <el-option :value="2" label="待沟通"></el-option>
                <el-option :value="3" label="沟通中"></el-option>
                <el-option :value="4" label="联系不到"></el-option>
                <el-option :value="5" label="已失联"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6" class="col-style">
              服务状态:
              <el-select class="ml-2" v-model="searchArr.service_status" placeholder="请选择" size="mini" clearable>
                <el-option :value="1" label="未分配"></el-option>
                <el-option :value="2" label="待服务"></el-option>
                <el-option :value="3" label="服务中"></el-option>
                <el-option :value="4" label="服务完成"></el-option>
                <el-option :value="5" label="服务暂停"></el-option>
                <el-option :value="6" label="服务停止"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4" class="col-style">
              手机一致:&nbsp;&nbsp;&nbsp;
              <el-radio-group v-model="searchArr.is_same_tel" size="mini">
                <el-radio-button label="y">是</el-radio-button>
                <el-radio-button label="n">否</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row :gutter="100" style="margin-top: 0.2rem">
            <el-col :span="6" class="col-style">
              转化人员:&nbsp;&nbsp;&nbsp;
              <el-cascader v-model="searchArr.conversion" placeholder="请选择转化人员" :options="personnelConvert" size="mini"
                :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
              </el-cascader>
            </el-col>
            <el-col :span="6" class="col-style">
              沟通顾问:&nbsp;&nbsp;&nbsp;
              <el-cascader v-model="searchArr.consultant" placeholder="请选择顾问" :options="personnel" size="mini"
                :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
              </el-cascader>
            </el-col>
            <el-col :span="6" class="col-style" v-if="searchArr.created_at">
              录入时间:
              <el-tooltip effect="dark" :content="createdAtTooltip" placement="top" class="ml-2">
                <el-date-picker v-model="searchArr.created_at" type="datetimerange" align="right" unlink-panels
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  :picker-options="typeInPickerOptions" :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" size="mini">
                </el-date-picker>
              </el-tooltip>
            </el-col>
            <el-col :span="6" class="col-style" v-else>
              录入时间:
              <el-date-picker class="ml-2" v-model="searchArr.created_at" type="datetimerange" align="right"
                unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="typeInPickerOptions" :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" size="mini">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row style="margin-top: 0.8rem">
            <el-col :span="24" style="text-align: center">
              <el-button type="primary" size="mini" @click="getData">查询</el-button>
              <el-button type="info" size="mini" @click="resetSome">重置</el-button>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-row class="mb-10" :gutter="10" style="margin-top: 10px">
      <el-col :span="6">
        <el-input v-model="searchArr.order_num" size="mini" placeholder="输入订单编号搜素" @input="handleOrderNumChange"
          clearable>
        </el-input>
      </el-col>
      <el-col :span="6">
        <el-select class="ml-2" placeholder="请输入客户手机号" v-model="searchArr.customer_phone" size="mini" clearable
          filterable remote reserve-keyword :loading="searchLoading" :remote-method="searchCustomerPhone"
          @change="getCustomerPhone">
          <el-option v-for="(item, index) in customerPhoneOptions" :value="item.id" :label="item.customer_phone"
            :key="index">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-select class="ml-2" v-model="searchArr.corporate_phone" placeholder="请输入法人手机号" size="mini" clearable
          filterable remote reserve-keyword :loading="searchLoading" :remote-method="searchCorporatePhone"
          @change="getCorporatePhone">
          <el-option v-for="(item, index) in corporatePhoneOptions" :value="item.id" :label="item.corporate_phone"
            :key="index">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="text-r">
        <!-- <el-button type="primary" size="mini" @click="handleAddOpen">录入</el-button> -->
        <el-tooltip effect="dark" content="批量分配人员" placement="top">
          <el-button type="warning" size="mini" @click="hugeAssign" style="margin-left: 0 !important">批量分配</el-button>
        </el-tooltip>
      </el-col>
    </el-row>

    <div class="middle-table">
      <el-table :data="pageData" height="calc(100vh - 316px)" size="mini" border style="width: 100%" v-cloak
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed label="订单编号" width="220">
          <template slot-scope="scope">
            <el-link class="ellipsis-link" type="primary"
              @click="handleOrderInfo(scope.row.id, scope.row.company, scope.row.order_num)">{{ scope.row.order_num }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="订单状态">
          <template slot-scope="scope">
            <span>{{ scope.row.order_status }}</span>
          </template>
        </el-table-column>
        <el-table-column label="沟通状态">
          <template slot-scope="scope">
            <span>{{ scope.row.chat_status }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务状态">
          <template slot-scope="scope">
            <span>{{ scope.row.service_status }}</span>
          </template>
        </el-table-column>
        <el-table-column label="顾问">
          <template slot-scope="scope">
            <span class="count-style" v-if="scope.row.advisor">{{
      scope.row.advisor.username
    }}</span>
          </template>
        </el-table-column>
        <el-table-column label="转化人">
          <template slot-scope="scope">
            <span v-if="scope.row.convert">{{ scope.row.trans.username }}</span>
            <span v-else>自助下单</span>
          </template>
        </el-table-column>
        <el-table-column label="服务人员">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.operator_name" icon="el-icon-user" circle size="mini"
              @click="handleOpenOperator(scope.$index, scope.row.id)"></el-button>
            <span v-else>{{ scope.row.operator_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单金额">
          <template slot-scope="scope">
            <span class="count-style">{{ scope.row.total_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="注册类型">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.reg_type" :content="scope.row.reg_type.reg_type_name" placement="top">
              <span class="count-style">{{ scope.row.reg_type.reg_type_name }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="客户手机" width="170">
          <template slot-scope="scope">
            <!-- <span class="count-style">{{ scope.row.customer_phone }}<br /></span> -->
            <phone-com v-if="scope.row.customer_phone" :comPhone="scope.row.customer_phone"
              :vagaryPhone="scope.row.vagary_phone_custome" style="display: inline-block" />
            <br />
            &nbsp;&nbsp;<span v-if="scope.row.phone_customer_isp">{{ scope.row.phone_customer_isp.province
              }}&nbsp;&nbsp;{{
      scope.row.phone_customer_isp.city
    }}</span>
          </template>
        </el-table-column>
        <el-table-column label="法人手机" width="170">
          <template slot-scope="scope">
            <!-- <span class="count-style">{{ scope.row.corporate_phone }}<br /></span> -->
            <phone-com v-if="scope.row.corporate_phone" :comPhone="scope.row.corporate_phone"
              :vagaryPhone="scope.row.vagary_phone_corporate" style="display: inline-block" />
            <br />
            &nbsp;&nbsp;<span v-if="scope.row.phone_corporate_isp">{{ scope.row.phone_corporate_isp.province
              }}&nbsp;&nbsp;{{
      scope.row.phone_corporate_isp.city
    }}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, index) in col" :key="index" :label="item.label" :prop="item.prop" :width="140">

          <template slot-scope="scope">
            <span v-if="item.prop === 'created_at'">
              <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
            </span>
            <span v-else class="count_style" style="display: inherit">{{
      scope.row[item.prop]
    }}
            </span>
          </template>

        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button :type="scope.row.edit_progress === '已完成' ? 'success' : 'primary'" :icon="scope.row.edit_progress === '已完成' ? 'el-icon-check' : 'el-icon-edit'" size="mini" circle @click="handleEditOpen(scope.$index, scope.row)"></el-button>
          </el-tooltip> -->
            <el-tooltip class="item" effect="dark" content="信息表整理" placement="top">
              <el-button :type="scope.row.organize_progress === '已完成' ? 'success' : 'warning'" :icon="scope.row.organize_progress === '已完成'
      ? 'el-icon-check'
      : 'el-icon-document'
      " size="mini" circle @click="handleArrangeOpen(scope.$index, scope.row)"
                :disabled="scope.row.order_status === '已退款'">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-phone-outline" circle
                @click="handCallLogsOpen(scope.row)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="企业微信群聊天记录" placement="top">
              <el-button type="warning" :disabled="scope.row.wx_work_chat_com ? false : true" @click="
      handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
      " size="mini" icon="el-icon-s-comment" circle></el-button>
            </el-tooltip>
            <!-- <el-tooltip class="item" effect="dark" content="客户注册信息采集表" placement="top">
              <el-button type="success" size="mini" icon="el-icon-s-data" circle
                @click="handleOpenRegInfoTable(scope.row)"></el-button>
            </el-tooltip> -->
            <el-tooltip class="item" effect="dark" content="客户注册信息采集表" placement="top">
              <router-link target="_blank" :to="{path:'/reg_info_create',query:{context:getString(scope.row.id,scope.row.order_num)}}">
                <el-button type="success" size="mini" icon="el-icon-s-data" circle style="margin-left: 0.2rem;"></el-button>
              </router-link>
            </el-tooltip>
            <!-- <el-popover placement="center" width="10" trigger="click" style="margin-left: 0.2rem">
            <el-tooltip style="display: inline-block; margin-left: 0.2rem" class="item" effect="dark" content="申请退款"
              placement="top">
              <el-button :disabled="scope.row.order_status === '已退款' || scope.row.order_status === '系统结单'" type="danger"
                size="mini" icon="el-icon-refresh-left" circle
                @click="applyRefundOrder(scope.$index, scope.row)"></el-button>
            </el-tooltip>
            <el-tooltip style="display: inline-block; margin-left: 0.2rem" class="item" effect="dark" content="系统结单"
              placement="top">
              <el-button :disabled="scope.row.order_status === '系统结单'" type="warning" size="mini" icon="el-icon-close"
                circle @click="systemOverOrder(scope.$index, scope.row)"></el-button>
            </el-tooltip>
            <el-button type="primary" size="mini" icon="el-icon-more" circle slot="reference"></el-button>
          </el-popover> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page-footer">
      <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
        :current-page="pageOption.currentPage" :page-size="pageOption.pageSize" :page-sizes="[10, 20, 30, 50, 100, 500]"
        :total="pageOption.total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- <el-drawer title="录入" :visible.sync="addDrawer" direction="rtl" :before-close="handleAddClose" size="40%">
      <div class="m-tabs-content">
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>订单基础信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">订单编号</el-col>
                <el-col :span="20" style="margin-bottom:0.2rem">
                  <el-input v-model="addForm.order_num" :size="inputSize" clearable></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">订单状态</el-col>
                <el-col :span="7" >
                  <el-select v-model="addForm.order_status" placeholder="请选择" clearable :size="inputSize">
                    <el-option value="未分配" label="未分配"></el-option>
                    <el-option value="沟通中" label="沟通中"></el-option>
                    <el-option value="服务中" label="服务中"></el-option>
                    <el-option value="联系不到客户" label="联系不到客户"></el-option>
                    <el-option value="服务完成" label="服务完成"></el-option>
                    <el-option value="申请退款中" label="申请退款中"></el-option>
                    <el-option value="已退款" label="已退款"></el-option>
                    <el-option value="系统结单" label="系统结单"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label" >订单类型</el-col>
                <el-col :span="7">
                  <el-select v-model="addForm.order_reg_type" :size="inputSize" placeholder="请选择">
                    <el-option v-for="reg in orderRegs" :key="reg.order_reg_id" :label="reg.order_reg_name"
                      :value="reg.order_reg_id"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">订单金额</el-col>
                <el-col :span="7">
                  <el-input v-model.trim="addForm.total_amount" :size="inputSize" clearable></el-input>
                </el-col>
                <el-col :span="4" class="m-label" :offset="2">订单转化人</el-col>
                <el-col :span="7">
                  <el-select v-model="addForm.convert" filterable placeholder="不选则为自助下单" clearable :size="inputSize">
                    <el-option v-for="option in personnel" :key="option.id" :label="option.username" :value="option.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">订单平台</el-col>
                <el-col :span="7">
                  <el-select v-model="addForm.platform" :size="inputSize" placeholder="请选择" @click.native="getFrom">
                    <el-option v-for="item in fromOptions" :key="item.id" :value="item.name"
                      :label="item.name"></el-option>
                  </el-select>
                </el-col>
              <div v-show="addForm.order_status !== '未分配'">
                <el-col :span="4" class="m-label" :offset="2">订单顾问</el-col>
                <el-col :span="7">
                  <el-select v-model="addForm.consultant" filterable placeholder="请选择" clearable :size="inputSize">
                    <el-option v-for="option in personnel" :key="option.id" :label="option.username" :value="option.id">
                    </el-option>
                  </el-select>
                </el-col>
                </div>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>客户信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">客户姓名</el-col>
                <el-col :span="7">
                  <el-input v-model="addForm.customer_name" :size="inputSize" clearable></el-input>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">客户手机</el-col>
                <el-col :span="7">
                  <el-input v-model="addForm.customer_phone" :size="inputSize" clearable></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">来源</el-col>
                <el-col :span="7">
                  <el-select v-model="addForm.sources" filterable placeholder="请选择" clearable :size="inputSize"
                    @change="handelSourcesSel('sources', '订单来源', 'addForm')">
                    <el-option v-for="option in sources" :key="option.source_id" :label="option.source_name"
                      :value="option.source_id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">收款方式</el-col>
                <el-col :span="7">
                  <el-select v-model="addForm.moneyin" placeholder="请选择" clearable filterable size="mini"
                    style="width: 100%" @click.native="loadMoneyInCate">
                    <el-option v-for="item in moneyInCateOptions" :key="item.id" :label="item.category_name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>服务信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">实际注册类型</el-col>
                <el-col :span="7">
                  <el-select v-model="addForm.actual_reg_type" placeholder="请选择" clearable :size="inputSize">
                    <el-option v-for="regType in regTypes" :key="regType.reg_type_id" :label="regType.reg_type_name"
                      :value="regType.reg_type_id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">是否刻章</el-col>
                <el-col :span="7" style="margin-top: .1rem;">
                  <el-tooltip :content="addForm.chapter" placement="top">
                    <el-switch v-model="addForm.chapter" active-color="#5789F4" inactive-color="#dcdfe6" active-value="是"
                      inactive-value="否">
                    </el-switch>
                  </el-tooltip>
                </el-col>
              </el-row>
              <el-row v-show="addForm.chapter === '否'">
                <el-col :span="4" class="m-label">不刻章原因</el-col>
                <el-col :span="20">
                  <el-input type="textarea" placeholder="请输入内容" v-model="addForm.not_chapter_reason"></el-input>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row class="bottom-btn">
          <el-button @click="submitAddForm('addForm')" size="mini" type="primary">保 存</el-button>
        </el-row>
      </div>
    </el-drawer> -->
    <el-drawer :title="'信息表整理： ' + out_trade_num" :visible.sync="arrangeDrawer" direction="rtl" custom-class="AIdrawer"
      :before-close="handleArrangeBeforeClose" size="40%">
      <div class="drawer-title" slot="title">信息表整理： {{ out_trade_num }}</div>
      <div class="m-tabs-content">
        <el-form label-width="130px" :model="arrangeData" size="small">
          <el-form-item label="法人姓名">
            <el-input v-model="arrangeData.corporate_name" :size="inputSize" clearable
              @blur.native.capture="handleArrangeChange('corporate_name', '法人姓名')"
              @clear="handleArrangeChange('corporate_name', '法人姓名')"></el-input>
          </el-form-item>
          <el-form-item label="法人手机">
            <el-input v-model="arrangeData.corporate_phone" :size="inputSize" clearable
              @blur.native.capture="handleArrangeChange('corporate_phone', '法人手机')"
              @clear="handleArrangeChange('corporate_phone', '法人手机')"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证">
            <el-input v-model="arrangeData.corporate_id_card" :size="inputSize" clearable
              @blur.native.capture="checkIdCardNo" @clear="checkIdCardNo"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            {{ arrangeData.corporate_sex }}
          </el-form-item>
          <el-form-item label="年龄">
            {{ arrangeData.age }}
          </el-form-item>
          <el-form-item label="所在城市">
            <el-cascader ref="cascaderAddr" v-model="arrangeData.legal_city_id" :options="citys" :size="inputSize"
              :props="{ expandTrigger: 'hover' }" filterable @change="handelArrangeCity">
            </el-cascader>
          </el-form-item>
          <el-form-item label="公司实际注册类型">
            <el-select v-model="arrangeData.actual_reg_type" placeholder="请选择" clearable filterable size="mini"
              @click.native="loadRegtype" @change="actChange">
              <!-- @change="loadTitle" -->
              <el-option v-for="item in regTypeData" :key="item.reg_type_id" :label="item.reg_type_name"
                :value="item.reg_type_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文档地址">
            <el-input @clear="handleArrangeChange('com_doc_url', '文档地址')" clearable
              @blur.native.capture="handleArrangeChange('com_doc_url', '文档地址')" type="text"
              v-model="arrangeData.com_doc_url" size="mini" />
          </el-form-item>
          <i class="el-icon-s-opportunity" style="color: #e6a23c; font-size: x-small; margin-left: 0.55rem">
            未填写整理人,和整理时间则系统默认为当前登录人和当前时间
          </i>
          <el-form-item label="整理人员" style="margin-top: 0.1rem">
            <el-cascader v-model="arrangeData.organizer" placeholder="请选择" :options="personnel" size="mini"
              :props="{ expandTrigger: 'hover' }" filterable @change="
      handelPeople('organizer', 'organizer_name', '信息表整理人', 'arrangeData')
      " :key="modalKey">
            </el-cascader>

            <!-- <el-select v-model="arrangeData.organizer" filterable placeholder="请选择" clearable :size="inputSize" @change="
              handelPeople(
                'organizer',
                'organizer_name',
                '信息表整理人',
                'arrangeData'
              )
            ">
              <el-option v-for="option in personnel" :key="option.id" :label="option.username" :value="option.id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="整理时间">
            <el-date-picker v-model="arrangeData.organizer_at" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
              :size="inputSize" @change="handleArrangeChange('organizer_at', '信息表整理时间')"></el-date-picker>
          </el-form-item>
        </el-form>
        <el-row class="mb-10">
          <el-upload :action="actionHost + '/api/upload/tyc/annex'" :headers="uploadHeader"
            :data="{ id: arrangeData.id }" :on-success="handleAnnexSuccess" :on-preview="handlePreview"
            :on-remove="handleRemove" :file-list="fileList">
            <el-link type="primary">上传附件</el-link>
          </el-upload>
        </el-row>
        <el-row style="text-align: right">
          <!-- active-value="已完成" inactive-value="未完成" @change="handleArrangeChange('organize_progress', '信息整理进度')"> -->

          <span>整理进度</span>
          <el-tooltip :content="arrangeData.organize_progress" placement="top">
            <el-switch v-model="arrangeData.organize_progress" active-color="#5789F4" inactive-color="#dcdfe6"
              active-value="已完成" inactive-value="未完成" @change="completeChange">
            </el-switch>
          </el-tooltip>
        </el-row>
        <!-- <el-row style="margin-top: 0.2rem" v-if="arrangeData.organize_progress === '已完成'">
          <span style="font-size:medium">设置文档地址</span>
          <el-input type="text" v-model="docAddress" size="mini" style="margin-top:0.1rem" />
          <el-button @click="setOrUpdateDocAddress" style="float:right;margin-top:0.1rem;" size="mini"
            type="primary">确定</el-button>
        </el-row> -->
      </div>
    </el-drawer>

    <el-drawer title="编辑" :visible.sync="upDrawer" direction="rtl" :before-close="handleUpdateClose" size="40%">
      <div class="m-tabs-content">
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>订单基础信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">派单时间</el-col>
                <el-col :span="7">
                  <el-input v-model="saveForm.assign_at" :size="inputSize" disabled></el-input>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">订单来源</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.platform" @click.native="getFrom" placeholder="请选择" :size="inputSize"
                    @change="handelSaveChange('platform', '订单来源')">
                    <el-option v-for="item in fromOptions" :key="item.id" :value="item.name"
                      :label="item.name"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">订单编号</el-col>
                <el-col :span="7">
                  <el-input v-model="saveForm.order_num" :size="inputSize" disabled></el-input>
                </el-col>
              </el-row>
              <el-row v-if="currentAuthId.indexOf(9) !== -1">
                <el-col :span="4" class="m-label">订单状态</el-col>
                <el-col :span="20">
                  <el-select v-model="saveForm.order_status" placeholder="请选择" :size="inputSize"
                    @change="handelSaveChange('order_status', '订单状态')">
                    <el-option value="未分配" label="未分配"></el-option>
                    <el-option value="沟通中" label="沟通中"></el-option>
                    <el-option value="服务中" label="服务中"></el-option>
                    <el-option value="联系不到客户" label="联系不到客户"></el-option>
                    <el-option value="申请退款中" label="申请退款中"></el-option>
                    <el-option value="已退款" label="已退款"></el-option>
                    <el-option value="服务完成" label="服务完成"></el-option>
                    <el-option value="系统结单" label="系统结单"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-if="saveForm.order_status === '联系不到客户'">
                <el-col :span="4" class="m-label">失联原因叙述</el-col>
                <el-col :span="20">
                  <el-input type="textarea" placeholder="请输入内容" v-model="saveForm.reason_for_loss"
                    @change="handelSaveChange('reason_for_loss', '失联原因叙述')"></el-input>
                </el-col>
              </el-row>
              <el-row v-if="saveForm.order_status === '申请退款中'">
                <el-col :span="4" class="m-label">是否可退款</el-col>
                <el-col :span="20">
                  <el-select v-model="saveForm.refundable" :size="inputSize" placeholder="请选择"
                    @change="handelSaveChange('refundable', '是否可退款')">
                    <el-option value="全额退款" label="全额退款"></el-option>
                    <el-option value="部分退款" label="部分退款"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-if="saveForm.order_status === '申请退款中'">
                <el-col :span="4" class="m-label">退款原因</el-col>
                <el-col :span="20">
                  <el-select v-model="saveForm.reason_for_return" :size="inputSize" clearable placeholder="请选择"
                    @change="refundCauseChange">
                    <el-option v-for="cause in causes" :key="cause.refund_id" :label="cause.refund_cause"
                      :value="cause.refund_id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-if="saveForm.order_status === '申请退款中'">
                <el-col :span="4" class="m-label">退款申请时间</el-col>
                <el-col :span="20">
                  <el-date-picker v-model="saveForm.refund_date" value-format="yyyy-MM-dd" type="date"
                    placeholder="退款申请时间" :size="inputSize"
                    @change="handelSaveChange('refund_date', '退款申请时间')"></el-date-picker>
                </el-col>
              </el-row>
              <el-row v-if="saveForm.order_status === '申请退款中'">
                <el-col :span="4" class="m-label">退款优先级</el-col>
                <el-col :span="20">
                  <el-select v-model="saveForm.refund_priority" :size="inputSize" placeholder="请选择"
                    @change="handelSaveChange('refund_priority', '退款优先级')">
                    <el-option value="普通" label="普通"></el-option>
                    <el-option value="紧急" label="紧急"></el-option>
                    <el-option value="非常紧急" label="非常紧急"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-if="saveForm.order_status === '申请退款中'">
                <el-col :span="4" class="m-label">反馈来源</el-col>
                <el-col :span="20">
                  <el-select v-model="saveForm.feedback_source" :size="inputSize" placeholder="请选择"
                    @change="handelSaveChange('feedback_source', '反馈来源')">
                    <el-option value="服务商" label="服务商"></el-option>
                    <el-option value="平台" label="平台"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-if="saveForm.order_status === '申请退款中'">
                <el-col :span="4" class="m-label">退款原因叙述</el-col>
                <el-col :span="20">
                  <el-input type="textarea" placeholder="请输入内容" v-model="saveForm.reason_for_return_info"
                    @change="handelSaveChange('reason_for_return_info', '退款原因叙述')"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">订单类型</el-col>
                <el-col :span="20">
                  <el-select v-model="saveForm.order_reg_type" placeholder="请选择" :size="inputSize" @change="
      handelOrderRegTypeSel('order_reg_type', '订单类型', 'saveForm')
      ">
                    <el-option v-for="reg in orderRegs" :key="reg.order_reg_id" :label="reg.order_reg_name"
                      :value="reg.order_reg_id"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-if="saveForm.order_reg_type === 5">
                <el-col :span="4" class="m-label">单品</el-col>
                <el-col :span="20">
                  <el-select v-model="saveForm.mealSingles" multiple filterable placeholder="请选择" clearable
                    :size="inputSize" @change="handelSingleChange">
                    <el-option v-for="meal in mealSingles" :key="meal.item_id" :label="meal.item_name"
                      :value="meal.item_id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>客户信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">客户来源</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.sources" filterable placeholder="请选择" clearable :size="inputSize"
                    @change="handelSourcesSel('sources', '客户来源', 'saveForm')">
                    <el-option v-for="option in sources" :key="option.source_id" :label="option.source_name"
                      :value="option.source_id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">客户姓名</el-col>
                <el-col :span="7">
                  <el-input v-model="saveForm.customer_name" :size="inputSize" clearable
                    @change="handelSaveChange('customer_name', '客户姓名')"></el-input>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>

        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>人员信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">订单转化人</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.convert" filterable placeholder="请选择" clearable :size="inputSize"
                    @change="handelSavePeopleSel('convert', '转化人', 'saveForm')">
                    <el-option v-for="option in personnel" :key="option.id" :label="option.username" :value="option.id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">服务对接人</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.operator" filterable placeholder="请选择" clearable :size="inputSize"
                    @change="handelSavePeopleSel('operator', '服务人员', 'saveForm')">
                    <el-option v-for="option in personnel" :key="option.id" :label="option.username" :value="option.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">沟通对接人</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.consultant" filterable placeholder="请选择" clearable :size="inputSize"
                    @change="handelSavePeopleSel('consultant', '订单顾问', 'saveForm')">
                    <el-option v-for="option in personnel" :key="option.id" :label="option.username" :value="option.id">
                    </el-option>
                  </el-select>
                </el-col>
                <!-- <el-col :span="4" :offset="2" class="m-label">实际注册类型</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.actual_reg_type" placeholder="请选择" :size="inputSize"
                    clearable @change="
                    handelRegTypeSel('actual_reg_type', '实际注册类型', 'saveForm')
                  ">
                    <el-option v-for="regType in regTypes" :key="regType.reg_type_id"
                      :label="regType.reg_type_name" :value="regType.reg_type_id"></el-option>
                  </el-select>
                </el-col> -->
              </el-row>
              <!-- <el-row>
                <el-col :span="4" class="m-label">行业特点</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.feature" filterable placeholder="请选择"
                    :size="inputSize" clearable @change="
                    handelSaveFeatureChange('feature', '行业特点', 'saveForm')
                  ">
                    <el-option v-for="feature in features" :key="feature.industry_id"
                      :label="feature.industry_name" :value="feature.industry_id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">个体落地城市</el-col>
                <el-col :span="7">
                  <el-input v-model="saveForm.ind_land_city" :size="inputSize" clearable
                    @change="handelSaveChange('ind_land_city', '个体落地城市')"></el-input>
                </el-col>
              </el-row> -->
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>收款信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">订单金额</el-col>
                <el-col :span="7">
                  <el-input v-model="saveForm.total_amount" :size="inputSize" clearable
                    @change="handelSaveChange('total_amount', '订单金额')"></el-input>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">收款方式</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.moneyin" placeholder="请选择" clearable filterable size="mini"
                    style="width: 100%" @click.native="loadMoneyInCate"
                    @change="handelSaveChange('moneyin', '收款方式', 'saveForm')">
                    <el-option v-for="item in moneyInCateOptions" :key="item.id" :label="item.category_name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label" style="margin-top: 0.4rem">收款凭证</el-col>
                <el-col :span="20">
                  <el-upload action="https://weixin.qiyehuo.com/api/admin/tyc_order/upfile" :headers="headers" multiple
                    ref="uploadMutiple" :file-list="fileLists" :limit="limit" :before-upload="beforeAvatarUpload"
                    :on-success="handleAvatarSuccess" :on-change="handleAvatarChange"
                    :on-preview="handlePictureCardPreview" :on-remove="handleRemoveR">
                  </el-upload>
                  <div id="preview" @paste="handlePaste"
                    style="border: 2px dashed #409eff; border-radius: 5px; padding: 10px">
                    <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <!-- <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>服务进度</span>
            </div>
            <div> -->
        <!-- <el-row>
                <el-col :span="4" :offset="2" class="m-label">实际注册类型</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.actual_reg_type" placeholder="请选择" :size="inputSize" clearable @change="
                    handelRegTypeSel('actual_reg_type', '实际注册类型', 'saveForm')
                  ">
                    <el-option v-for="regType in regTypes" :key="regType.reg_type_id" :label="regType.reg_type_name"
                      :value="regType.reg_type_id"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">行业特点</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.feature" filterable placeholder="请选择" :size="inputSize" clearable @change="
                    handelSaveFeatureChange('feature', '行业特点', 'saveForm')
                  ">
                    <el-option v-for="feature in features" :key="feature.industry_id" :label="feature.industry_name"
                      :value="feature.industry_id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">是否代账</el-col>
                <el-col :span="7">
                  <el-select v-model="saveForm.proxy_demand" placeholder="请选择" :size="inputSize"
                    @change="handelSaveChange('proxy_demand', '是否代账')">
                    <el-option value="否" label="否"></el-option>
                    <el-option value="是" label="是"></el-option>
                    <el-option value="转化中" label="转化中"></el-option>
                    <el-option value="待转化" label="待转化"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-show="saveForm.proxy_demand === '是'">
                <el-col :span="4" class="m-label">代账套餐</el-col>
                <el-col :span="20">
                  <el-select v-model="saveForm.proxy_meal" placeholder="请选择" :size="inputSize" clearable
                    @change="handeCombolSel('proxy_meal', '代账套餐', 'saveForm')">
                    <el-option v-for="meal in meals" :key="meal.combo_id" :label="meal.combo_name" :value="meal.combo_id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-show="saveForm.proxy_demand === '是'">
                <el-col :span="4" class="m-label">转化时间</el-col>
                <el-col :span="20">
                  <el-date-picker v-model="saveForm.proxy_meal_at" type="date" placeholder="选择日期" :size="inputSize"
                    value-format="yyyy-MM-dd" @change="handelSaveChange('proxy_meal_at', '转化时间')"></el-date-picker>
                </el-col>
              </el-row>
              <el-row v-show="saveForm.proxy_demand !== '是'">
                <el-col :span="4" class="m-label">未下代账原因</el-col>
                <el-col :span="20">
                  <el-input v-model="saveForm.not_proxy_reason" type="textarea" :size="inputSize" clearable
                    @change="handelSaveChange('not_proxy_reason', '未下代账原因')"></el-input>
                </el-col>
              </el-row> -->
        <!-- <el-row>
                <el-col :span="4" class="m-label">编辑进度</el-col>
                <el-col :span="7" style="margin-top: .1rem;">
                  <el-tooltip :content="saveForm.edit_progress" placement="top">
                    <el-switch v-model="saveForm.edit_progress" active-color="#5789F4" inactive-color="#dcdfe6"
                      active-value="已完成" inactive-value="未完成" @change="handelSaveChange('edit_progress', '编辑进度')">
                    </el-switch>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row> -->
      </div>
    </el-drawer>

    <el-dialog title="批量分配人员" :visible.sync="operatorVisible" width="30%" :before-close="handleOperatorClose">
      <div style="margin-bottom: 0.4rem" v-if="batchTag">
        <el-cascader v-model="communicator" placeholder="请选择沟通人员" :options="personnel" size="mini"
          :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
        </el-cascader>
      </div>
      <div>
        <el-cascader v-model="operator" placeholder="请选择服务人员" :options="personnel" size="mini"
          :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
        </el-cascader>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleOperatorSave">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="电话联系记录" :visible.sync="callLogsDrawer" direction="rtl" :before-close="handleCallLogsBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs :company="company" :phone="callPhone" :phone1="callPhone1" :phone2="callPhone2"
            :phone3="callPhone3"></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer :title="'订单信息： ' + out_trade_num" :visible.sync="orderInfoVisible" direction="rtl"
      custom-class="AIdrawer" size="50%" :before-close="handleOrderInfoClose">
      <div class="drawer-title" slot="title">订单信息： {{ out_trade_num }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId"></order-info>
      </div>
    </el-drawer>
    <!-- 系统结单 -->
    <el-dialog title="系统结单" :visible.sync="systemOverOrderDrawer" width="45%">
      <el-form label-width="100px">
        <el-form-item label="系统结单理由">
          <el-input type="textarea" v-model="systemOverOrderData.feedback" size="mini"
            placeholder="请输入系统结单理由"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitSystemOverOrder()">提 交</el-button>
      </span>
    </el-dialog>
    <el-drawer title="企业微信聊天记录" :visible.sync="wxChatDrawer" direction="rtl" :before-close="handleWxChatBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkchatCompany"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import OrderInfo from "common/OrderInfo";
import DateFormatter from 'common/DateFormatter';
import { timeMixin } from "../../lib/timeMixin.js";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from "common/PhoneCom";
import CryptoJS from 'crypto-js'

export default {
  name: "Order",
  components: {
    CallLogs,
    OrderInfo,
    WxWorkChat,
    DateFormatter,
    PhoneCom
  },
  mixins: [timeMixin],
  data() {
    return {
      activeOpen: "",
      wxChatDrawer: false,
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      fromOptions: [],
      inputSize: "small",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      fileLists: [],
      limit: 10,
      needUrl: [],
      change: false,
      fileNameList: [],
      uploadHeader: { Authorization: localStorage.token },
      imgPath: this.$store.state.imgPath,
      orderNumChange: false,
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      col: [
        {
          label: "客户姓名",
          prop: "customer_name",
        },
        // {
        //   label: '客户手机',
        //   prop: 'customer_phone'
        // },
        {
          label: "法人姓名",
          prop: "corporate_name",
        },
        // {
        //   label: '法人手机',
        //   prop: 'corporate_phone'
        // },
        {
          label: "录入时间",
          prop: "created_at",
        },
      ],
      adminUserOptions: [],
      orderStatusOptions: [],
      customerPhoneOptions: [],
      corporatePhoneOptions: [],
      searchLoading: false,
      searchArr: {
        order_num: "",
        order_status: "",
        chat_status: "",
        service_status: "",
        consultant: "",
        created_at: "",
        customer_phone: "",
        corporate_phone: "",
        conversion: "",
        is_same_tel: "",
      },
      addDrawer: false,
      addForm: {
        platform: null,
        order_num: null,
        order_status: "未分配",
        total_amount: 0,
        customer_name: "",
        customer_phone: "",
        order_reg_type: null,
        actual_reg_type: null,
        feature: null,
        convert: null,
        consultant: null,
        chapter: "否",
        not_chapter_reason: "",
        sources: null,
        moneyin: "",
      },
      addRules: {
        platform: [{ required: true, message: "请选择平台", trigger: "blur" }],
        order_num: [{ required: true, message: "请输入订单编号", trigger: "blur" }],
        order_status: [{ required: true, message: "请选择订单状态", trigger: "blur" }],
        moneyin: [{ required: true, message: "请选择收款方式", trigger: "blur" }],
        total_amount: [
          { required: true, message: "订单金额不能为空", trigger: "blur" },
          {
            pattern: /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g,
            message: "订单金额类型错误",
            trigger: "blur",
          },
        ],
        customer_phone: [
          { required: true, message: "客户手机号不能为空", trigger: "blur" },
        ],
        order_reg_type: [{ required: true, message: "请选择订单类型", trigger: "blur" }],
      },
      orderRegs: [],
      regTypes: [],
      features: [],
      personnel: [],
      sources: [],
      meals: [],
      mealSingles: [],
      causes: [],
      arrangeDrawer: false,
      regTypeData: [],
      arrangeData: {
        index: null,
        id: 0,
        corporate_name: "",
        corporate_phone: "",
        corporate_id_card: "",
        corporate_sex: "",
        province_id: 0,
        legal_city_id: 0,
        location: "",
        age: null,
        organizer: [],
        organizer_at: '',
        organize_progress: "未完成",
        actual_reg_type: null,
        com_doc_url: "",
      },
      modalKey: 0,
      docAddress: "",
      fileList: [],
      citys: [],
      saveForm: {
        index: null,
        id: 0,
        order_num: "",
        assign_at: "",
        actual_reg_type: "",
        order_status: "",
        reason_for_loss: "",
        reason_for_return: [],
        reason_for_return_info: "",
        refund_date: "",
        proxy_demand: "是",
        not_proxy_reason: "",
        proxy_meal: "",
        proxy_meal_at: "",
        mealSingles: [],
        proxy_num: "",
        ind_land_city: "",
        edit_progress: "未完成",
        consultant: null,
        convert: null,
        feature: "",
        total_amount: 0,
        customer_name: "",
        refundable: null,
        meal_convert: null,
        order_reg_type: null,
        refund_priority: "",
        feedback_source: "",
        sources: null,
        platform: null,
        operator: null,
        moneyin: "",
      },
      upDrawer: false,
      operatorVisible: false,
      operatorId: null,
      operatorIndex: null,
      operator: [],
      activeName: "info",
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      orderInfoVisible: false,
      orderInfoId: null,
      moneyInCateOptions: [],
      hugeData: [],
      hugeSign: false,
      batchTag: false,
      communicator: [],
      // 当前用户身份
      // currentAuthId: null,
      currentAuthId: [],
      systemOverOrderDrawer: false,
      systemOverOrderData: {
        id: null,
        feedback: "",
      },
      additionalData: { value: "自助下单", label: "自助下单" },
      out_trade_num: ''
    };
  },
  // created() {
  //   this.arrangeData.organizer_at = new Date().toISOString().substr(0, 10);
  // },
  computed: {
    personnelConvert() {
      return [this.additionalData, ...this.personnel];
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    searchStr: {
      get: function () {
        let str = "";
        for (let key in this.searchArr) {
          str += "&" + key + "=" + this.searchArr[key];
        }

        return str;
      },
    },
    typeInPickerOptions: function () {
      var _this = this;
      return {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const todayDate = new Date().toLocaleDateString();
              var dateArr = _this.nowDate(todayDate);
              const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
              const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const dd = new Date();
              dd.setDate(dd.getDate() - 1);
              var yesterDate = dd.toLocaleDateString();
              var dateArr = _this.nowDate(yesterDate);
              const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
              const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var now = new Date();
              const year = now.getFullYear();
              const month = now.getMonth();
              const day = now.getDate();
              const week = now.getDay();

              let start = new Date(year, month, day - week + 1, 0, 0, 0);
              let end = new Date(year, month, day - week + 7, 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              var dateS = _this.getWeek(-1, 0).split("-");
              var dateE = _this.getWeek(-1, 1).split("-");

              let start = new Date(dateS[0], dateS[1] - 1, dateS[2], 0, 0, 0);
              let end = new Date(dateE[0], dateE[1] - 1, dateE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              var str = _this.getCurrentDate();

              var arr = _this.getfirstDateAndlastDate(str);

              var arrS = arr[0].split("-");
              var arrE = arr[1].split("-");

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              var str = _this.fromLastMonth();

              var arr = _this.getfirstDateAndlastDate(str);

              var arrS = arr[0].split("-");
              var arrE = arr[1].split("-");

              var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
              var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      };
    },
    createdAtTooltip() {
      if (this.searchArr.created_at) {
        return this.searchArr.created_at[0] + "至" + this.searchArr.created_at[1];
      }
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      console.log(defaultDate)
      return defaultDate;
    },
    beforeAvatarUpload(file) {
      const isLt100M = file.size / (1024 * 100) < 100;
      if (!isLt100M) {
        this.$message.error("上传总大小不能超过 100MB!");
        return false;
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid });
      }
    },
    handleAvatarChange(res, file) {
      this.fileLists = file;
      this.change = true;
    },
    handlePictureCardPreview(file) {
      this.fileNameList = file.name;
    },
    handleRemoveR(file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1);
        }
      });
      this.fileLists = fileList;
      this.change = true;
    },
    handleOpenRegInfoTable(row) {
      let routeUrl = this.$router.resolve({
        path: "/reg_info_create",
        query: { id: row.id }
      });
      window.open(routeUrl.href, '_blank');
    },
    getObj(id,num) {
      return {id:id,keywords:this.getKey(id,num),num:num}
    },
    getString(id,num) {
      let obj = {id:id,keywords:this.getKey(id,num),num:num}
      return JSON.stringify(obj)
    },
    getKey(id,num) {
      let val = `${id}${num}`
      const secretKey = 'ysyaes'
      const encryptedMessage = CryptoJS.AES.encrypt(val, secretKey).toString()
      return encryptedMessage
    },
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        file = items[i].getAsFile();
      }
      if (this.fileLists.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
        return;
      }
      this.$refs.uploadMutiple.handleStart(file); // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit(); // 提交图片上传队列
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    handleSelectionChange(val) {
      this.hugeData = val;
    },
    hugeAssign() {
      if (this.hugeData.length === 0) {
        this.$message.warning("请先勾选或全选条目！");
        return false;
      }
      this.hugeSign = true;
      this.batchTag = true;
      this.operatorVisible = true;
    },
    // 系统结单
    systemOverOrder(index, row) {
      this.systemOverOrderDrawer = true;
      this.systemOverOrderData.id = row.id;
    },
    submitSystemOverOrder() {
      if (!this.systemOverOrderData.feedback) {
        this.$message.error("请填写结单理由!");
        return false;
      }
      this.$axios
        .post("api/admin/tyc_order/system_order", { data: this.systemOverOrderData })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.systemOverOrderDrawer = false;
            this.handelGetOrders();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // 申请退款
    applyRefundOrder(index, row) {
      this.$confirm("确认发起该订单申请退款吗？", "申请退款", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get("/api/admin/tyc_order/apply_refund_order?order_id=" + row.id)
            .then((res) => {
              const { data } = res;
              if (data.code === 0) {
                this.$message.success("");
                this.handelGetOrders();
              } else {
                this.$message.error(data.msg);
              }
            });
        })
        .catch(() => { });
    },
    setOrUpdateDocAddress() {
      this.$axios
        .post("api/admin/tyc_orders/update_doc_url", {
          id: this.arrangeData.id,
          com_doc_url: this.docAddress,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.handelGetOrders();
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    loadRegtype() {
      this.$axios
        .get("api/order/get_real_regtype")
        .then(({ data }) => {
          if (data.code === 1) {
            this.regTypeData = data.data;
          }
        })
        .catch();
    },
    loadMoneyInCate() {
      this.$axios
        .get("api/moneyin/getcate")
        .then(({ data }) => {
          if (data.code === 1) {
            this.moneyInCateOptions = data.data;
          }
        })
        .catch();
    },
    getData() {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
      this.activeOpen = "";
    },
    resetSome() {
      this.searchArr.order_status = "";
      this.searchArr.chat_status = "";
      this.searchArr.service_status = "";
      this.searchArr.consultant = "";
      this.searchArr.created_at = "";
      this.searchArr.conversion = "";
      this.searchArr.is_same_tel = "";
      this.activeOpen = "";
    },
    nowDate(date) {
      return date.split("/");
    },
    getWeek(n, type) {
      // 周
      let now = new Date();
      let day = now.getDay(); // 返回星期几的某一天;
      if (!type) {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1);
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7);
        } else {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber);
        }
      } else {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1 + 6); // 在周开始的日期上+6天=周结束
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7 + 6);
        } else {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber);
        }
      }
      let date = now.getDate();
      let month = now.getMonth() + 1;

      let s =
        now.getFullYear() +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (date < 10 ? "0" + date : date);
      return s;
    },
    getfirstDateAndlastDate(dateC) {
      var dateStr = dateC;
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month > 12) {
        month = 1;
        year++;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var monthLastDay = new Date(year, month, 0).getDate();
      var firstDate = year + "-" + month + "-" + "01";
      var lastDate = year + "-" + month + "-" + monthLastDay;
      return [firstDate, lastDate];
    },
    getCurrentDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    fromLastMonth() {
      var date = new Date();
      var lastMonthDate = "";
      // 获取当前几号，如果小于10则补0
      var day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      var month = date.getMonth();
      var year = date.getFullYear();
      // 上个月小于1则证明跨年，年份减1
      if (month < 1) {
        lastMonthDate = year - 1 + "-12-" + day;
      } else {
        // 月份小于10则补0
        if (month < 10) {
          month = "0" + month;
        }
        lastMonthDate = year + "-" + month + "-" + day;
      }
      return lastMonthDate;
    },
    loadAdminUser() {
      this.$axios
        .get("api/expmanage/getreceiver")
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions = data.data;
          }
        })
        .catch();
    },
    loadOrderStatus() {
      this.$axios
        .get("api/admin/other_orders_get_order_status")
        .then(({ data }) => {
          if (data.code === 1) {
            this.orderStatusOptions = data.data;
          }
        })
        .catch();
    },
    handelGetOrders() {
      this.$axios
        .get(
          "/api/admin/other_orders?page=" +
          this.pageOption.currentPage +
          "&pageSize=" +
          this.pageOption.pageSize +
          this.searchStr
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.pageData = data.data.orders.data;
            this.pageOption.total = data.data.orders.total;
            this.orderRegs = data.data.orderRegs;
            this.regTypes = data.data.regTypes;
            this.features = data.data.features;
            this.personnel = data.data.personnel;
            this.citys = data.data.cities;
            this.meals = data.data.meals;
            this.mealSingles = data.data.mealSingles;
            this.sources = data.data.sources;
            this.causes = data.data.causes;
            this.orderNumChange = false;
            // this.currentAuthId = data.data.roleAuth.roles[0].id
            this.currentAuthId = data.data.roleAuth;
          }
        });
    },
    handleOrderNumChange(val) {
      if (this.orderNumChange) return;
      this.orderNumChange = true;
      setTimeout(() => {
        this.pageOption.currentPage = 1;
        this.handelGetOrders();
      }, 800);
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    handleAddOpen() {
      this.addDrawer = true;
    },
    clearForm() {
      this.addForm.platform = null;
      this.addForm.order_num = null;
      this.addForm.order_status = "已付款";
      this.addForm.total_amount = 0;
      this.addForm.customer_name = "";
      this.addForm.customer_phone = "";
      this.addForm.order_reg_type = null;
      this.addForm.actual_reg_type = null;
      this.addForm.feature = null;
      this.addForm.convert = null;
      this.addForm.consultant = null;
      this.addForm.chapter = "否";
      this.addForm.not_chapter_reason = "";
      this.addForm.sources = null;
      this.addForm.moneyin = "";
    },
    handleAddClose(done) {
      this.clearForm();
      done();
    },
    submitAddForm(formName) {
      if (this.addForm.order_status == "沟通中" && !this.addForm.consultant) {
        this.$message.error("请选择订单顾问");
        return;
      }
      this.$axios.post("/api/admin/other_orders", this.addForm).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.handelGetOrders();
          this.addDrawer = false;
          this.clearForm();
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    completeChange(val) {
      if (val === "已完成") {
        this.isCompleted();
      } else {
        this.handleArrangeChange("organize_progress", "信息整理进度");
      }
    },
    isCompleted() {
      this.$axios
        .get("api/admin/tyc_order/is_completed", {
          params: {
            id: this.arrangeData.id,
          },
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.handleArrangeChange("organize_progress", "信息整理进度");
          } else {
            this.$message.error(data.msg);
            this.arrangeData.organize_progress = "未完成";
          }
        })
        .catch();
    },
    handleArrangeOpen(index, row) {
      // console.log(row);
      this.arrangeData.index = index;
      this.arrangeData.id = row.id;
      this.loadRegtype();
      this.arrangeData.actual_reg_type = row.actual_reg_type;
      this.arrangeData.corporate_name = row.corporate_name;
      this.arrangeData.corporate_phone = row.corporate_phone;
      this.arrangeData.corporate_id_card = row.corporate_id_card;
      this.arrangeData.corporate_sex = row.corporate_sex;
      this.arrangeData.location = row.location;
      this.arrangeData.province_id = row.province_id;
      this.arrangeData.legal_city_id = row.legal_city_id;
      this.arrangeData.age = row.age;
      if (row.organizer) {
        this.arrangeData.organizer.push(row.organizer.branch_id, row.organizer.id);
        this.modalKey++;
      }
      this.arrangeData.organizer_at = row.organizer_at;
      // this.arrangeData.organizer_at = this.getCurrentTime();
      this.arrangeData.organize_progress = row.organize_progress;
      this.arrangeData.com_doc_url = row.com_doc_url;
      this.fileList = row.annexes;
      this.out_trade_num = row.order_num;
      this.arrangeDrawer = true;
    },
    handleArrangeBeforeClose(done) {
      this.clearArrangeData();
      done();
    },
    clearArrangeData() {
      this.arrangeData.actual_reg_type = "";
      this.regTypeData = [];
      this.arrangeData.index = null;
      this.arrangeData.id = 0;
      this.arrangeData.corporate_name = "";
      this.arrangeData.corporate_phone = "";
      this.arrangeData.corporate_id_card = "";
      this.arrangeData.corporate_sex = "";
      this.arrangeData.location = "";
      this.arrangeData.province_id = 0;
      this.arrangeData.legal_city_id = 0;
      this.arrangeData.age = null;
      this.arrangeData.organizer = [];
      this.arrangeData.organizer_at = "";
      this.arrangeData.organize_progress = "未完成";
      this.arrangeData.actual_reg_type = "";
      this.fileList = [];
      this.arrangeData.com_doc_url = "";
    },
    actChange() {
      this.handleArrangeChange("actual_reg_type", "实际注册类型");
    },
    handleArrangeChange(field, fieldName) {
      let index = this.arrangeData.index;
      if (this.pageData[index][field] === this.arrangeData[field]) return;
      this.$axios
        .put("/api/admin/tyc_orders/field/" + this.arrangeData.id, {
          field: String(field),
          fieldName: fieldName,
          value: this.arrangeData[field],
          old: this.pageData[index][field],
          realType: this.arrangeData.actual_reg_type,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index][field] = this.arrangeData[field];
            // console.log(this.arrangeData.organize_progress)
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    checkIdCardNo() {
      let idCardNo = this.arrangeData.corporate_id_card;
      if (!/^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo)) {
        this.arrangeData.corporate_sex = "";
        this.arrangeData.age = null;
        this.$message.error("身份证格式错误");
        return;
      }

      let check = false;

      if (idCardNo.length === 15) {
        check = this.check15IdCardNo(idCardNo);
      } else {
        check = this.check18IdCardNo(idCardNo);
      }

      if (!check) {
        this.arrangeData.corporate_sex = "";
        this.arrangeData.age = null;
        this.$message.error("身份证格式错误");
        return;
      }

      if (parseInt(idCardNo.substr(16, 1)) % 2 === 1) {
        this.arrangeData.corporate_sex = "男";
      } else {
        this.arrangeData.corporate_sex = "女";
      }

      let yearBirth = idCardNo.substring(6, 10);
      let monthBirth = idCardNo.substring(10, 12);
      let dayBirth = idCardNo.substring(12, 14);
      let myDate = new Date();
      let monthNow = myDate.getMonth() + 1;
      let dayNow = myDate.getDay();
      let age = myDate.getFullYear() - yearBirth;
      if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
        age--;
      }

      this.arrangeData.age = age;

      this.updateIDCard();
    },
    updateIDCard() {
      let index = this.arrangeData.index;
      if (this.pageData[index].corporate_id_card === this.arrangeData.corporate_id_card) {
        return;
      }
      let params = {
        corporate_id_card: this.arrangeData.corporate_id_card,
        corporate_sex: this.arrangeData.corporate_sex,
        age: this.arrangeData.age,
        old: this.pageData[index].corporate_id_card,
      };

      this.$axios
        .put("/api/admin/tyc_orders/idCard/" + this.arrangeData.id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index].corporate_id_card = this.arrangeData.corporate_id_card;
            this.pageData[index].corporate_sex = this.arrangeData.corporate_sex;
            this.pageData[index].age = this.arrangeData.age;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    check15IdCardNo(idCardNo) {
      if (
        /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(
          idCardNo
        )
      ) {
        return true;
      }
    },
    check18IdCardNo(idCardNo) {
      if (
        /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(
          idCardNo
        )
      ) {
        return true;
      }
    },
    handelArrangeCity(value) {
      let input = this.getcity(value);

      this.arrangeData.location = input[0] + " / " + input[1];
      this.arrangeData.province_id = value[0];
      this.arrangeData.legal_city_id = value[1];
      let index = this.arrangeData.index;

      if (this.pageData[index].legal_city_id === this.arrangeData.legal_city_id) {
        return;
      }

      this.$axios
        .put("/api/admin/tyc_orders/arrangeCity/" + this.arrangeData.id, {
          location: this.arrangeData.location,
          province_id: this.arrangeData.province_id,
          legal_city_id: this.arrangeData.legal_city_id,
          old: this.pageData[index].location,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index].location = this.arrangeData.location;
            this.pageData[index].province_id = this.arrangeData.province_id;
            this.pageData[index].legal_city_id = this.arrangeData.legal_city_id;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getcity(arr) {
      let city = [];
      let obj = {};

      obj = this.citys.find((item) => {
        return item.value === arr[0];
      });

      if (obj) {
        let children = obj.children;
        city.push(obj.label);
        for (var i = 0; i < children.length; i++) {
          if (children[i].value === arr[1]) city.push(children[i].label);
        }
      }
      return city;
    },
    handelPeople(field, relatedField, fieldName, type) {
      let index = this[type].index;
      let name = this.getPeopleName(this[type][field][1]);
      let tmpOldId =
        this.pageData[index][field] !== null ? this.pageData[index][field].id : null;
      let old = this.getPeopleName(tmpOldId);

      if (name === old) return;

      this.handelPeopleChange(field, relatedField, fieldName, type, index, name, old);
    },
    getPeopleName(val) {
      // let obj = {}
      let name = "";
      // console.log(this.personnel);return;
      // obj = this.personnel.find(item => {
      //   return item.id === val
      // })
      let obj = this.findValue(val);
      // console.log(obj);
      // this.personnel.forEach((item) => {
      //     item.children.forEach((child) => {
      //       if (child.value === val) {
      //         obj = child;
      //       }   // 访问每个子数组的 value 属性
      //     });
      // });

      // console.log(obj);return;

      if (obj) name = obj.label;

      return name;
    },
    findValue(val) {
      let obj = null;
      outerLoop: for (let item of this.personnel) {
        for (let child of item.children) {
          if (child.value === val) {
            obj = child;
            break outerLoop; // 在找到匹配值后跳出外部循环
          }
        }
      }
      return obj;
    },
    handelPeopleChange(field, relatedField, fieldName, type, index, name, old) {
      let params = {
        field: String(field),
        relatedField: relatedField,
        fieldName: fieldName,
        value: this[type][field][1],
        name: name,
        old: old,
      };

      this.$axios
        .put("/api/admin/tyc_orders/people/" + this[type].id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            // console.log('111', this.pageData[index][field])
            // this.pageData[index][field] = this[type][field][1]
            // this.pageData[index][relatedField] = name
            this.handelGetOrders();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },

    handleAnnexSuccess(res, file) {
      if (res.code === 0) {
        this.fileList.push({
          id: res.data.id,
          name: file.name,
          url: this.imgPath + res.data.store_result,
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    handlePreview(file) {
      window.location.href = file.url;
    },
    handleRemove(file, fileList) {
      this.$axios.delete("/api/admin/tyc_annex/" + file.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let index = this.arrangeData.index;
          this.fileList = fileList;
          this.pageData[index].annexes = fileList;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleEditOpen(index, row) {
      this.saveForm.index = index;
      this.saveForm.id = row.id;
      this.saveForm.order_num = row.order_num;
      this.saveForm.assign_at = row.assign_at;
      this.saveForm.actual_reg_type = row.actual_reg_type;
      this.saveForm.order_status = row.order_status;
      this.saveForm.reason_for_loss = row.reason_for_loss;
      this.saveForm.reason_for_return = row.refund_cause_id;
      this.saveForm.reason_for_return_info = row.reason_for_return_info;
      this.saveForm.refund_date = row.refund_date;
      this.saveForm.proxy_demand = row.proxy_demand;
      this.saveForm.not_proxy_reason = row.not_proxy_reason;
      this.saveForm.proxy_meal = row.proxy_meal;
      this.saveForm.proxy_meal_at = row.proxy_meal_at;
      this.saveForm.mealSingles = this.getSingleIds(row.meal_singles);
      this.saveForm.proxy_num = row.proxy_num;
      this.saveForm.ind_land_city = row.ind_land_city;
      this.saveForm.edit_progress = row.edit_progress;
      this.saveForm.consultant = row.consultant;
      this.saveForm.convert = row.convert;
      this.saveForm.feature = row.feature;
      this.saveForm.total_amount = row.total_amount;
      this.saveForm.customer_name = row.customer_name;
      this.saveForm.refundable = row.refundable;
      this.saveForm.meal_convert = row.meal_convert;
      this.saveForm.order_reg_type = row.order_reg_type;
      this.saveForm.refund_priority = row.refund_priority;
      this.saveForm.feedback_source = row.feedback_source;
      this.saveForm.sources = row.sources;
      this.saveForm.platform = row.platform;
      this.saveForm.operator = row.operator;
      this.saveForm.moneyin = row.moneyin;
      this.upDrawer = true;
    },
    handleUpdateClose(done) {
      this.clearUpdateData();
      done();
    },
    clearUpdateData() {
      this.saveForm.index = null;
      this.saveForm.id = 0;
      this.saveForm.order_num = "";
      this.saveForm.assign_at = "";
      this.saveForm.actual_reg_type = "";
      this.saveForm.order_status = "";
      this.saveForm.reason_for_loss = "";
      this.saveForm.reason_for_return = null;
      this.saveForm.reason_for_return_info = "";
      this.saveForm.refund_date = "";
      this.saveForm.proxy_demand = "是";
      this.saveForm.not_proxy_reason = "";
      this.saveForm.proxy_meal = "";
      this.saveForm.proxy_meal_at = "";
      this.saveForm.mealSingles = [];
      this.saveForm.proxy_num = "";
      this.saveForm.ind_land_city = "";
      this.saveForm.edit_progress = "未完成";
      this.saveForm.consultant = null;
      this.saveForm.convert = null;
      this.saveForm.feature = "";
      this.saveForm.total_amount = 0;
      this.saveForm.customer_name = "";
      this.saveForm.refundable = null;
      this.saveForm.meal_convert = null;
      this.saveForm.order_reg_type = null;
      this.saveForm.refund_priority = "";
      this.saveForm.feedback_source = "";
      this.saveForm.platform = null;
      this.saveForm.operator = null;
      this.saveForm.moneyin = "";
    },
    handelSaveChange(field, fieldName) {
      let index = this.saveForm.index;
      let check = true;

      if (field === "total_amount") {
        check = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(this.saveForm[field]);
      }

      if (!check) {
        this.$message.error("订单金额类型错误");
        this.saveForm[field] = 0;
        return;
      }

      if (field === "order_status" && this.saveForm[field] === "服务完成") {
        if (!this.pageData[index].corporate_name) {
          this.saveForm[field] = this.pageData[index][field];
          this.$message.error("请先完善法人姓名");
          return;
        }

        if (!this.pageData[index].corporate_phone) {
          this.saveForm[field] = this.pageData[index][field];
          this.$message.error("请先完善法人手机号");
          return;
        }
      }

      if (this.pageData[index][field] === this.saveForm[field]) return;
      this.$axios
        .put("/api/admin/tyc_orders/field/" + this.saveForm.id, {
          field: String(field),
          fieldName: fieldName,
          value: this.saveForm[field],
          old: this.pageData[index][field],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index][field] = this.saveForm[field];
            if (field === "proxy_demand" && this.saveForm[field] === "是") {
              this.pageData[index].not_proxy_reason = "";
              this.saveForm.not_proxy_reason = "";
            }

            if (field === "order_status" && this.saveForm[field] === "未分配") {
              this.pageData[index].advisor = null;
              this.pageData[index].consultant = null;
            }

            if (field === "order_status" && this.saveForm[field] !== "已退款") {
              this.saveForm.reason_for_return = null;
              this.pageData[index].refund_cause_id = null;
              this.pageData[index].refunds = null;
            }

            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelSavePeopleSel(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getPeopleName(this[type][field]);
      let old = this.getPeopleName(this.pageData[index][field]);
      if (name === old) return;
      this.handelCommonSelChange(field, fieldName, type, index, name, old);
    },
    handelCommonSelChange(field, fieldName, type, index, name, old) {
      let params = {
        field: String(field),
        fieldName: fieldName,
        value: this[type][field],
        name: name,
        old: old,
      };
      this.$axios
        .put("/api/admin/tyc_orders/common_sel/" + this[type].id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index][field] = this[type][field];
            if (field === "consultant") {
              this.pageData[index].advisor = {
                id: this[type][field],
                username: name,
              };
            }
            if (field === "convert") {
              this.pageData[index].trans = {
                id: this[type][field],
                username: name,
              };
            }
            if (field === "feature") {
              this.pageData[index].industry = {
                industry_id: this[type][field],
                industry_name: name,
              };
            }
            if (field === "operator") {
              this.pageData[index].operator_name = name;
            }
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelSourcesSel(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getSourcesName(this[type][field]);
      let old = this.getSourcesName(this.pageData[index][field]);

      if (name === old) return;

      this.handelSelSub(field, fieldName, type, index, name, old);
    },
    getSourcesName(val) {
      let obj = {};
      let name = "";
      obj = this.sources.find((item) => {
        return item.source_id === val;
      });
      if (obj) name = obj.source_name;
      return name;
    },
    handelSelSub(field, fieldName, type, index, name, old) {
      let params = {
        field: String(field),
        fieldName: fieldName,
        value: this[type][field],
        nameStr: name,
        oldStr: old,
      };

      this.$axios
        .put("/api/admin/tyc_orders/sel/" + this[type].id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index][field] = this[type][field];
            if (field === "actual_reg_type") {
              this.pageData[index].reg_type = {
                reg_type_id: this[type][field],
                reg_type_name: name,
              };
            }

            if (field === "order_reg_type") {
              this.pageData[index].order_reg = {
                order_reg_id: this[type][field],
                order_reg_name: name,
              };
            }

            if (field === "sources") {
              this.pageData[index].sources = this[type][field];
              this.pageData[index].source = {
                source_id: this[type][field],
                source_name: name,
              };
            }
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelOrderRegTypeSel(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getOrderRegTypeName(this[type][field]);
      let old = this.getOrderRegTypeName(this.pageData[index][field]);

      if (name === old) return;

      this.handelSelSub(field, fieldName, type, index, name, old);
    },
    getOrderRegTypeName(val) {
      let obj = {};
      let name = "";
      obj = this.orderRegs.find((item) => {
        return item.order_reg_id === val;
      });
      if (obj) name = obj.order_reg_name;
      return name;
    },
    handelRegTypeSel(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getRegTypeName(this[type][field]);
      let old = this.getRegTypeName(this.pageData[index][field]);

      if (name === old) return;

      this.handelSelSub(field, fieldName, type, index, name, old);
    },
    getRegTypeName(val) {
      let obj = {};
      let name = "";
      obj = this.regTypes.find((item) => {
        return item.reg_type_id === val;
      });
      if (obj) name = obj.reg_type_name;
      return name;
    },
    handelSaveFeatureChange(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getFeatureName(this[type][field]);
      let old = this.getFeatureName(this.pageData[index][field]);

      this.handelCommonSelChange(field, fieldName, type, index, name, old);
    },
    getFeatureName(val) {
      let obj = {};
      let name = "";
      obj = this.features.find((item) => {
        return item.industry_id === val;
      });

      if (obj) name = obj.industry_name;

      return name;
    },
    handelSingleChange(val) {
      let singleNames = this.getSingleNames(this.saveForm.mealSingles);
      let oldNames = this.getSingleNames(this.pageData[this.saveForm.index].meal_singles);
      this.$axios
        .put("/api/admin/meal/singles/" + this.saveForm.id, {
          mealSingles: this.saveForm.mealSingles,
          singleNames: singleNames,
          oldNames: oldNames,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.setPageDataMeal(this.saveForm.mealSingles);
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getSingleNames(ids) {
      let name = "";
      for (var i = 0; i < ids.length; i++) {
        this.mealSingles.forEach((item) => {
          if (ids[i].item_id && ids[i].item_id === item.item_id) {
            name += item.item_name + ", ";
          } else if (ids[i] === item.item_id) {
            name += item.item_name + ", ";
          }
        });
      }

      return name;
    },
    setPageDataMeal(mealSingles) {
      this.pageData[this.saveForm.index].meal_singles = [];
      for (var i = 0; i < mealSingles.length; i++) {
        for (var j = 0; j < this.mealSingles.length; j++) {
          if (mealSingles[i] === this.mealSingles[j].item_id) {
            this.pageData[this.saveForm.index].meal_singles.push({
              item_id: this.mealSingles[j].item_id,
              item_name: this.mealSingles[j].item_name,
            });
          }
        }
      }
    },
    handeCombolSel(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getComboName(this[type][field]);
      let old = this.getComboName(this.pageData[index][field]);

      if (name === old) return;

      this.handelSelSub(field, fieldName, type, index, name, old);
    },
    getComboName(val) {
      let obj = {};
      let name = "";
      obj = this.meals.find((item) => {
        return item.combo_id === val;
      });

      if (obj) name = obj.combo_name;

      return name;
    },
    getSingleIds(arr) {
      if (!arr) return [];

      let ids = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].item_id) {
          ids.push(arr[i].item_id);
        } else {
          ids.push(arr[i]);
        }
      }

      return ids;
    },
    refundCauseChange(value) {
      let index = this.saveForm.index;
      let oldStr = this.getRefundNames(this.pageData[index].refund_cause_id);
      let newStr = this.getRefundNames(value);
      let params = {
        reason_for_return: this.saveForm.reason_for_return,
        oldStr: oldStr,
        newStr: newStr,
      };
      this.$axios
        .put("/api/admin/tyc_orders/refund/" + this.saveForm.id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index].refund_cause_id = this.saveForm.reason_for_return;
            this.pageData[index].refunds = {
              refund_id: this.saveForm.reason_for_return,
              refund_cause: newStr,
            };
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getRefundNames(val) {
      let str = "";
      for (var i = 0; i < this.causes.length; i++) {
        if (val === this.causes[i].refund_id) {
          str = this.causes[i].refund_cause;
        }
      }

      return str;
    },
    handleOpenOperator(index, id) {
      this.operatorIndex = index;
      this.operatorId = id;
      this.batchTag = false;
      this.operatorVisible = true;
    },
    handleOperatorClose(done) {
      this.operatorIndex = null;
      this.operatorId = null;
      done();
    },
    handleOperatorSave() {
      if (!this.operator && !this.communicator) {
        this.$message.error("请选择人员！");
        return;
      }
      if (this.hugeSign) {
        this.doHugeSign();
      } else {
        this.$axios
          .put("/api/admin/operator/" + this.operatorId, {
            operator: this.operator,
          })
          .then((res) => {
            const { data } = res;
            if (data.code === 0) {
              this.$message.success(data.msg);
              this.handelGetOrders();
              this.operatorIndex = null;
              this.operatorId = null;
              this.operator = [];
              this.operatorVisible = false;
            } else {
              this.$message.error(data.msg);
            }
          });
      }
    },
    doHugeSign() {
      this.$axios
        .put("api/tyc_order/huge_assign", {
          operator: this.operator,
          communicator: this.communicator,
          orders: this.hugeData,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.hugeSign = false;
            this.batchTag = false;
            this.operatorVisible = false;
            this.operator = [];
            this.communicator = [];
            this.$message.success(data.msg);
            this.handelGetOrders();
          }
        })
        .catch();
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        if (row.customer_phone) this.callPhone1.push(row.customer_phone);
        if (row.corporate_phone) this.callPhone2.push(row.corporate_phone);
        if (row.company_obj) {
          if (row.company_obj.company_name) {
            this.company = row.company_obj.company_name;
          }
          if (row.company_obj.user) {
            this.callPhone.push(row.company_obj.user.phone);
          }
          if (row.company_obj.docking_phone) {
            this.callPhone3.push(row.company_obj.docking_phone);
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleOrderInfo(orderId, companyName, order_num) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
        this.out_trade_num = order_num;
      });
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    searchCustomerPhone(query) {
      if (query !== "") {
        this.searchLoading = true;
        this.searchCustomerPhoneItem(query);
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.customerPhoneOptions = [];
      }
    },
    searchCustomerPhoneItem(query) {
      this.$axios
        .get("api/admin/other_orders/search_customer_phone", {
          params: {
            customerPhone: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.customerPhoneOptions = data.data;
          }
        })
        .catch();
    },
    searchCorporatePhone(query) {
      if (query !== "") {
        this.searchLoading = true;
        this.searchCorporatePhoneItem(query);
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.corporatePhoneOptions = [];
      }
    },
    searchCorporatePhoneItem(query) {
      this.$axios
        .get("api/admin/other_orders/search_corporate_phone", {
          params: {
            corporatePhone: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.corporatePhoneOptions = data.data;
          }
        })
        .catch();
    },
    getCustomerPhone() {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    getCorporatePhone() {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    getFrom() {
      this.$axios
        .get("api/admin/other_orders/get_froms")
        .then(({ data }) => {
          if (data.code === 1) {
            this.fromOptions = data.data;
          }
        })
        .catch();
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  mounted() {
    this.handelGetOrders();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style scoped>
.ml-2 {
  margin-left: 0.2rem;
}

.col-style {
  white-space: nowrap;
}
</style>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.otherOrder >>> .el-drawer__header {
  font-size: 0.36rem;
  font-weight: 400;
  color: #4D84FE;
}

.otherOrder >>> .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 0.5rem;
}

.otherOrder >>> .video {
  background-color: #606266 !important;
  color: #fff !important;
}

.otherOrder >>> .el-timeline-item__node--normal {
  left: 0;
}

.otherOrder >>> .el-collapse-item__wrap {
  position: fixed;
  width: -webkit-fill-available;
  z-index: 222 !important;
}

.otherOrder {
  marginLeft();
  .middle-table{
    z-index: 1;
  }
  .page-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 80px;
    background: #fff;
    width: 100%;
    z-index: 2;
    .el-pagination {
      padding-top: 15px;
    }
  }
  .text-r {
    text-align: right;
  }
}

.clearfix:before, .clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.count {
  padding-left: 0.2rem;
  line-height: 0.56rem;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-10 {
  margin-bottom: 0.2rem;
}

.mb-20 {
  margin-bottom: 0.4rem;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-40 {
  margin-top: 0.8rem;
}

.mt-50 {
  margin-top: 1rem;
}

.mb-50 {
  margin-bottom: 1rem;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;

  .tabs-title {
    color: #5789F4;
  }

  .m-label {
    line-height: 0.64rem;
  }

  .el-row {
    margin-bottom: 0.4rem;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}

.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}

.bottom-btn {
  padding: 0.2rem;
  text-align: right;
}

.count-style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tr {
  text-align: right;
}

.otherOrder >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.dot {
  display: inline-block;
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
  margin-right: 0.1rem;
  top: 0;
  left: -0.2rem;
  bottom: 0;
  margin: auto;
}

.el-card__body p {
  margin-top: 0.4rem;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.el-date-editor {
  width: 100% !important;
}

.warningText {
  color: rgb(208, 35, 35);
}

.setBadge >>> .el-badge__content.is-fixed {
  top: 0.22rem;
  right: 0.06rem;
}

.el-icon-warning {
  color: rgb(208, 35, 35);
}

.check-succ {
  color: #67C23A;
}

.infinite-list-item {
  margin: 0.2rem 0.2rem 0.4rem 0.2rem;
}

.infinite-item-content {
  display: inline-block;
  margin-top: 0.2rem;
  padding: 0 0.36rem 0 0.36rem;
  line-height: 0.9rem;
  background-color: #eef0f5;
}

.infinite-item-voice {
  display: inline-block;
  width: 1rem;
  margin-top: 0.2rem;
  padding: 0 0.36rem 0 0.36rem;
  line-height: 0.7rem;
  background-color: rgb(191, 221, 253);
  cursor: pointer;
}

.popper__arrow {
  position: absolute;
  top: 0.04rem;
  left: 0.36rem;
  display: block;
  margin-right: 0.06rem;
  border-color: transparent;
  border-style: solid;
  border-width: 0.18rem;
  border-top-width: 0;
  border-bottom-color: #eef0f5;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}

.imgType {
  width: 2rem;
  cursor: pointer;
}

.imgerr {
  width: 4rem;
  height: 2rem;
  cursor: pointer;
}

.wrap {
  position: relative;
  width: 20px;
  height: 20px;
  margin: 0.1rem auto;
}

.box {
  position: absolute;
  width: 17px;
  height: 17px;
  left: 0;
  bottom: 0;
  background: #333;
  border-top-right-radius: 15px;
  transform: rotateZ(45deg);
  -webkit-transform: rotateZ(45deg);
}

.box-an {
  animation: obox linear 0.8s 5000;
}

@keyframes obox {
  0% {
    background: #333;
  }

  33% {
    background: #333;
  }

  66% {
    background: #fff;
  }

  100% {
    background: #333;
  }
}

@keyframes obox {
  0% {
    background: #333;
  }

  33% {
    background: #333;
  }

  66% {
    background: #fff;
  }

  100% {
    background: #333;
  }
}

.box1 {
  position: absolute;
  width: 15px;
  height: 15px;
  background-color: #bfddfd;
  left: 0;
  bottom: 0;
  border-top-right-radius: 15px;
}

.box2 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 12px;
  height: 12px;
  background: #333;
  border-top-right-radius: 15px;
}

.box2-an {
  animation: obox2 linear 1s 5000;
}

@keyframes obox2 {
  0% {
    background: #333;
  }

  33% {
    background: #333;
  }

  66% {
    background: #fff;
  }

  100% {
    background: #333;
  }
}

@keyframes obox2 {
  0% {
    background: #333;
  }

  33% {
    background: #333;
  }

  66% {
    background: #fff;
  }

  100% {
    background: #333;
  }
}

.box3 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 9px;
  height: 9px;
  background-color: #bfddfd;
  border-top-right-radius: 15px;
}

.box4 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 6px;
  height: 6px;
  background: #333;
  border-top-right-radius: 15px;
}

.mb2{
  margin-bottom: 0.2rem;
}

.ellipsis-link {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.AIdrawer .drawer-title {
  background-color: #ecf5ff;
  padding: 10px;
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/Order.vue